
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/profile",
      function () {
        return require("private-next-pages/settings/profile.js");
      }
    ]);
  